/**************************************************
 * Nombre:       Home_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {DOCUMENTOS} from "../../../Constantes";
import Tarjeta_Documentos from "../../Tarjetas/Tarjeta_Documentos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Documentos = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 4 : 8}
                    >

                        {DOCUMENTOS.map((it, index) => (
                            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Documentos item={it}/>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Documentos